// import GiftIcon from '@material-ui/icons/CardGiftcard';
// import styled from 'styled-components';

// import SimpleModal from '#/components/basic/modal/SimpleModal';
// import SimpleRoundedButton from '#/components/basic/Button/SimpleRoundedButton';
import { useEffect, useState } from 'react';

import { fetchAppUpdateInformation } from '#/api/apiApp';
import { useInterval } from '#/components/hooks';
import { trackEvent } from '#/lib/analytics';

export const useWebClientReloader = () => {
  // Dev timeout for testing UI purposes
  const devReloadTimeout15 =
    window?.location?.search === '?dev=reloadcountdown15';

  const [version, setVersion] = useState<number>();
  const [reloadInSec, setReloadInSec] = useState<number | false | undefined>(
    devReloadTimeout15 ? 15 : undefined
  );

  const reloadWindow = () => window?.location?.reload();

  useEffect(() => {
    // Get current version
    fetchAppUpdateInformation()
      .then(info => setVersion(info.version))
      .catch(error => console.warn(error));
  }, []);

  useInterval(() => {
    if (reloadInSec) {
      return;
    }
    fetchAppUpdateInformation()
      .then(latest => {
        if (!version) {
          setVersion(latest.version);
          return;
        }
        if (
          latest.version > version &&
          Date.now() >= new Date(latest.enforceAfter).getTime()
        ) {
          trackEvent('app_reload_initiated');
          setReloadInSec(latest.automaticReloadTimeout);
        }
      })
      .catch(error => console.warn(error));
  }, 120_000); // 2 minutes

  // This is not super accurate countdown, but should work
  useInterval(() => {
    if (reloadInSec === undefined || reloadInSec === false) {
      return;
    }
    const newRemaining = reloadInSec - 5;
    if (newRemaining <= 0) {
      reloadWindow();
    } else if (newRemaining > 0) {
      setReloadInSec(newRemaining);
    }
  }, 5000);

  return {
    updateCountdownRemainingSec: reloadInSec,
    reloadNow: reloadWindow,
  };
};

// do not display on patch releases
// Test by disabling hot reload - https://github.com/facebook/create-react-app/issues/2519
// export default function WebClientReloader() {
//   return null;
//   // return reloadInSec ? (
//   //   <SimpleModal
//   //     onClose={() => {
//   //       // Hide until next check
//   //       setReloadInSec(undefined);
//   //     }}
//   //   >
//   //     <div style={{ textAlign: 'center' }}>
//   //       <GiftIcon fontSize="large" />
//   //       <br />
//   //       <h1>App update available!</h1>
//   //       <p>Please reload web client to get latest features.</p>
//   //       <br />
//   //       <SimpleRoundedButton onClick={reloadWindow}>
//   //         Reload Now
//   //       </SimpleRoundedButton>
//   //       <br />
//   //       <br />
//   //       <p style={{ color: 'gray' }}>
//   //         We are going to reload IDEX automatically in {reloadInSec} seconds
//   //       </p>
//   //     </div>
//   //   </SimpleModal>
//   // ) : null;
// }
